(ns ycweb.components.csvexport
  "A download dialog any export can reuse. Each filter is a select whose chosen
   value becomes a query parameter, leaving one blank exports everything for it,
   and every list is rebuilt from the rows the other choices still match, so an
   incompatible combination is never on offer."
  (:require
   [cemerick.url :as url]
   [clojure.string :as str]
   [rum.core :as rum]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.util.core :as yuc]))

(defn- selected-cursor [app-atom]
  (rum/cursor-in app-atom [:csv-export :selected]))

(defn- as-key [value]
  (when-let [v (yuc/presence value)] (str v)))

(defn matches?
  "Whether a row satisfies every chosen filter, ignoring the one named by except."
  [filters selected row & [except]]
  (every?
    (fn [{:keys [id value-fn]}]
      (or (= id except) (not (yuc/presence (get selected id))) (= (as-key (value-fn row)) (get selected id))))
    filters))

(defn filter-options
  "A filter's options from the rows the other choices still match, sorted by label."
  [filters selected rows {:keys [id value-fn text-fn]}]
  (->>
    rows
    (filter #(matches? filters selected % id))
    (keep (fn [row]
            (when-let [k (as-key (value-fn row))]
              {:value k :label (or (when text-fn (yuc/presence (text-fn row))) k)})))
    distinct
    (sort-by :label)))

(defn export-url
  "The export href with every chosen filter appended as a query parameter."
  [href filters selected]
  (let [params
        (keep
          (fn [{:keys [id]}]
            (when-let [v (yuc/presence (get selected id))]
              (str (name id) "=" (url/url-encode (str v)))))
          filters)]
    (if (seq params)
      (str href (if (str/includes? href "?") "&" "?") (str/join "&" params))
      href)))

(defn- default-count-text [n]
  (str n " row" (when (not= 1 n) "s")))

(rum/defc modal-body < rum/reactive [app-atom]
  (let [{:keys [title text filters rows count-text]} (:config (rum/react (grid/modal-cursor app-atom)))
        selected (rum/react (selected-cursor app-atom))
        matching (count (filter #(matches? filters selected %) rows))]
    (grid/modal-confirm-body app-atom title
      (-> [:div (when text [:p text])]
        (into
          (map
            (fn [{:keys [id label placeholder] :as f}]
              (let [options (filter-options filters selected rows f)]
                (rum/with-key
                  (forms/select label (rum/cursor-in app-atom [:csv-export :selected id])
                    (cons
                      {:text (or placeholder "- All -") :value ""}
                      (map (fn [{:keys [value label]}] {:text label :value value}) options))
                    {:disabled (empty? options)})
                  (name id))))
            filters))
        (conj [:p.form-hint ((or count-text default-count-text) matching)])))))

(rum/defc modal-footer < rum/reactive [app-atom]
  (let [{:keys [href filters rows download-text]} (:config (rum/react (grid/modal-cursor app-atom)))
        selected (rum/react (selected-cursor app-atom))
        nothing? (not-any? #(matches? filters selected %) rows)]
    (grid/button-row
      {:left-text "Cancel"
       :left-no-icon true
       :left-fn #(grid/close-modal app-atom)
       :right-text (or download-text "Download")
       :right-no-icon true
       :right-disabled? nothing?
       :right-fn
       (fn []
         (when-not nothing?
           ;; A new tab, so an error reply never replaces the screen.
           #?(:cljs (.open js/window (export-url href filters selected) "_blank"))
           (grid/close-modal app-atom)))})))

(defmethod grid/modal-config :csv-export/modal [_ _ _]
  {:body modal-body
   :footer modal-footer
   :modal-type :alert})

(defn open-export-modal
  "Opens the filtered download dialog. config: :title :text :href :rows :download-text
   :count-text and :filters [{:id :label :value-fn :text-fn :placeholder}], where :value-fn
   gives a row's query parameter value and :text-fn what its option shows."
  [app-atom config]
  (swap! app-atom assoc-in [:csv-export :selected] {})
  (grid/open-modal app-atom :csv-export/modal config))
